var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-stripe" },
    [
      _c("pixConfig", {
        attrs: {
          pix: _vm.pix,
          pixAffiliations: _vm.pixAffiliations,
          account: _vm.account,
          merchantId: _vm.merchantId,
          accountLoading: _vm.accountLoading,
          modalPix: _vm.modalPix,
        },
        on: {
          defaultPixRecipientEmit: _vm.defaultPixRecipientEmit,
          onToggleModalPix: _vm.onToggleModalPix,
        },
      }),
      _vm.permissionIsEnabled("settings.payments.credit_card:view")
        ? _c(
            "creditcard-config",
            {
              attrs: {
                title: _vm.$t("account.settings.credit-card.title"),
                callback: _vm.saveCreditConfig,
                loading: _vm.accountLoading,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.payments.credit_card:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.creditCard,
                    _vm.paymentMethods.creditCard
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.credit-card.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.credit-card.status")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledCreditCard" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.creditCard.enabled,
                                    expression: "creditCard.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  checked: "checked",
                                  type: "checkbox",
                                  id: "enabledCreditCard",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.creditCard.enabled)
                                    ? _vm._i(_vm.creditCard.enabled, null) > -1
                                    : _vm.creditCard.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.creditCard.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.creditCard,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.creditCard,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.creditCard, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "account.settings.credit-card.active"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label _required",
                              attrs: { for: "gatewayCreditCard" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.credit-card.gateway")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              attrs: { id: "gatewayCreditCard" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.creditCard.gateway,
                                      expression: "creditCard.gateway",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.creditCard,
                                        "gateway",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.gateways, function (gateway, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: gateway.key },
                                    },
                                    [_vm._v(" " + _vm._s(gateway.value) + " ")]
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.payments.debit_card:view")
        ? _c(
            "debitcard-config",
            {
              attrs: {
                title: _vm.$t("account.settings.debit-card.title"),
                callback: _vm.saveDebitConfig,
                loading: _vm.accountLoading,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.payments.debit_card:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.debitCard,
                    _vm.paymentMethods.debitCard
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.debit-card.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.debit-card.status")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledCreditDebit" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.debitCard.enabled,
                                    expression: "debitCard.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  checked: "checked",
                                  type: "checkbox",
                                  id: "enabledCreditDebit",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.debitCard.enabled)
                                    ? _vm._i(_vm.debitCard.enabled, null) > -1
                                    : _vm.debitCard.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.debitCard.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.debitCard,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.debitCard,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.debitCard, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "account.settings.debit-card.active"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label _required",
                              attrs: { for: "gatewayCreditDebit" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.debit-card.gateway")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              attrs: { id: "gatewayCreditDebit" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.debitCard.gateway,
                                      expression: "debitCard.gateway",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.debitCard,
                                        "gateway",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.gateways, function (gateway, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: gateway.key },
                                    },
                                    [_vm._v(" " + _vm._s(gateway.value) + " ")]
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.payments.boleto:view")
        ? _c(
            "boleto-config",
            {
              attrs: {
                title: _vm.$t("account.settings.boleto.title"),
                callback: _vm.saveBoletoConfig,
                loading: _vm.accountLoading,
                formIsInvalid: !_vm.instructionsIsValid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.payments.boleto:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetBoleto(_vm.boleto, _vm.paymentMethods.boleto)
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.boleto.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.boleto.status"))
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledBoleto" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.boleto.enabled,
                                    expression: "boleto.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  checked: "checked",
                                  type: "checkbox",
                                  id: "enabledBoleto",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.boleto.enabled)
                                    ? _vm._i(_vm.boleto.enabled, null) > -1
                                    : _vm.boleto.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.boleto.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.boleto,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.boleto,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.boleto, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.boleto.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm.isBoletoStoneVisible
                        ? _c(
                            "div",
                            { staticClass: "el-chunk" },
                            [
                              _vm.statusBoletoStone.alert
                                ? _c(
                                    "emd-alert",
                                    {
                                      attrs: {
                                        variant:
                                          _vm.statusBoletoStone.alert.type,
                                        title:
                                          _vm.statusBoletoStone.alert.title,
                                      },
                                      on: {
                                        cancel: _vm.onCleanAlertBoletoStone,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "content" }, [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.statusBoletoStone.alert
                                                .description
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "emd-form-group" },
                                [
                                  _c("emd-frame", {
                                    attrs: {
                                      badges: _vm.statusBoletoStone.badges,
                                      title: _vm.$t(
                                        "account.settings.boleto.stone.title"
                                      ),
                                      active: true,
                                      "button-position":
                                        _vm.statusBoletoStone.type === "Enabled"
                                          ? "bottom"
                                          : "middle",
                                      text: _vm.statusBoletoStone.text,
                                      "button-label":
                                        _vm.statusBoletoStone.button,
                                      "button-hide":
                                        !_vm.statusBoletoStone.method,
                                    },
                                    on: { click: _vm.statusBoletoStone.method },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "emd-form-group" },
                                [
                                  _c("emd-frame", {
                                    attrs: {
                                      badges: [],
                                      title: _vm.$t(
                                        "account.settings.boleto.other-bank.title"
                                      ),
                                      text: _vm.$t(
                                        "account.settings.boleto.other-bank.description"
                                      ),
                                      "button-hide": true,
                                    },
                                    on: { click: null },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isProductionAccount
                        ? _c("div", { staticClass: "el-chunk" }, [
                            _c("div", { staticClass: "emd-form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "emd-label _required",
                                  attrs: { for: "boletoBank" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.boleto.bank")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "emd-select",
                                  attrs: { id: "boletoBank" },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.boleto.bank,
                                          expression: "boleto.bank",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.boleto,
                                            "bank",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.bankOptionsBoleto,
                                      function (bank, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: { value: index },
                                          },
                                          [_vm._v(" " + _vm._s(bank) + " ")]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _c("div", {
                                    staticClass: "emd-select__arrow",
                                  }),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label _required",
                              attrs: { for: "gatewayBoleto" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.boleto.gateway")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              attrs: { id: "gatewayBoleto" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.boleto.gateway,
                                      expression: "boleto.gateway",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.boleto,
                                        "gateway",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.gateways, function (gateway, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: gateway.key },
                                    },
                                    [_vm._v(" " + _vm._s(gateway.value) + " ")]
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "minDueDays" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.boleto.due-days")
                                )
                              ),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.boleto.due_days,
                                expression: "boleto.due_days",
                              },
                            ],
                            staticClass: "emd-input",
                            attrs: {
                              id: "minDueDays",
                              type: "text",
                              placeholder: "Mínimo de 1 dia",
                            },
                            domProps: { value: _vm.boleto.due_days },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.boleto,
                                  "due_days",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "div",
                          {
                            staticClass: "emd-form-group",
                            class: { _state_error: !_vm.instructionsIsValid },
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "emd-label _required",
                                attrs: { for: "instructionsBoleto" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "account.settings.boleto.instructions"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.boleto.instructions,
                                  expression: "boleto.instructions",
                                },
                              ],
                              staticClass: "emd-input",
                              attrs: {
                                id: "instructionsBoleto",
                                type: "text",
                                cols: "30",
                                rows: "10",
                              },
                              domProps: { value: _vm.boleto.instructions },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.boleto,
                                      "instructions",
                                      $event.target.value
                                    )
                                  },
                                  _vm.validateInstructions,
                                ],
                              },
                            }),
                            !_vm.instructionsIsValid
                              ? _c(
                                  "span",
                                  { staticClass: "emd-input-feedback" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.boleto.instructions-feedback"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.payments.voucher:view")
        ? _c(
            "voucher-config",
            {
              attrs: {
                title: _vm.$t("account.settings.voucher.title"),
                callback: _vm.saveVoucherConfig,
                loading: _vm.accountLoading,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.payments.voucher:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.voucher,
                    _vm.paymentMethods.voucher
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.voucher.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.voucher.status")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledVoucher" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.voucher.enabled,
                                    expression: "voucher.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  checked: "checked",
                                  type: "checkbox",
                                  id: "enabledVoucher",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.voucher.enabled)
                                    ? _vm._i(_vm.voucher.enabled, null) > -1
                                    : _vm.voucher.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.voucher.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.voucher,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.voucher,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.voucher, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.voucher.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label _required",
                              attrs: { for: "gatewayVoucher" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.voucher.gateway")
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              attrs: { id: "gatewayVoucher" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.voucher.gateway,
                                      expression: "voucher.gateway",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.voucher,
                                        "gateway",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.gateways, function (gateway, index) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: gateway.key },
                                    },
                                    [_vm._v(" " + _vm._s(gateway.value) + " ")]
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.payments.cash:view")
        ? _c(
            "cash-config",
            {
              attrs: {
                title: _vm.$t("account.settings.cash.title"),
                callback: _vm.saveCashConfig,
                loading: _vm.accountLoading,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.payments.cash:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(_vm.cash, _vm.paymentMethods.cash)
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.cash.config")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.cash.status"))
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enabledWalletGlobal" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cash.enabled,
                                    expression: "cash.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: {
                                  checked: "checked",
                                  type: "checkbox",
                                  id: "enabledWalletGlobal",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.cash.enabled)
                                    ? _vm._i(_vm.cash.enabled, null) > -1
                                    : _vm.cash.enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.cash.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.cash,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.cash,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.cash, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.cash.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _c("modal-create-account", {
        attrs: { isOpen: _vm.modalBoletoStone.createAccountIsOpen },
        on: {
          onCreateAccount: _vm.onRegisterBoletoStone,
          onClose: function ($event) {
            _vm.onToggleModalBoletoStone("createAccountIsOpen")()
          },
        },
      }),
      _c("modal-fail-habilitation", {
        attrs: { isOpen: _vm.modalBoletoStone.failHabilitationIsOpen },
        on: {
          onClose: function ($event) {
            _vm.onToggleModalBoletoStone("failHabilitationIsOpen")()
          },
        },
      }),
      _vm.modalBoletoStone.enabledIsOpen
        ? _c("modal-password", {
            attrs: {
              size: "big",
              text: _vm.$t(
                "account.settings.boleto.stone.enable-with-password"
              ),
              callback: (password) =>
                _vm.onEnableOrDisableBoletoStone(password, true),
            },
            on: {
              cancel: function ($event) {
                _vm.onToggleModalBoletoStone("enabledIsOpen")()
              },
            },
          })
        : _vm._e(),
      _c("modal-disable", {
        attrs: {
          isOpen: _vm.modalBoletoStone.disabledIsOpen,
          isLoad: _vm.modalBoletoStone.isLoad,
          error: _vm.modalBoletoStone.hasError,
        },
        on: {
          onDisable: (password) =>
            _vm.onEnableOrDisableBoletoStone(password, false),
          onClose: function ($event) {
            _vm.onToggleModalBoletoStone("disabledIsOpen")()
          },
        },
      }),
      _c("modal-create-key", {
        attrs: {
          isOpen: _vm.modalPix.createKeyIsOpen,
          isLoad: _vm.modalPix.createIsLoad,
          error: _vm.modalPix.createHasError,
        },
        on: {
          onSubmit: (password) => _vm.onCreatePixKey(password),
          onClose: function ($event) {
            return _vm.onToggleModalPix("createKeyIsOpen")
          },
          onCancel: function ($event) {
            return _vm.onToggleModalPix("createKeyIsOpen")
          },
        },
      }),
      _c("modal-delete-key", {
        attrs: {
          isOpen: _vm.modalPix.deleteKeyIsOpen,
          isLoad: _vm.modalPix.deleteIsLoad,
          error: _vm.modalPix.deleteHasError,
          accountName: _vm.defaultPixRecipient.name,
        },
        on: {
          onDelete: (password) => _vm.onDeletePixKey(password),
          onClose: function ($event) {
            return _vm.onToggleModalPix("deleteKeyIsOpen")
          },
          onCancel: function ($event) {
            return _vm.onToggleModalPix("deleteKeyIsOpen")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }